'use client';

import React, { FC } from 'react';
import AllReviews from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/AllReviews';
import ReviewReply from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/ReviewReply';
import { countCommentReplies } from '@/utils/post/comments/countCommentReplies';
import ReviewAllReplies from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/ReviewAllReplies';
import Comment from '@/components/(postTypes)/platforms/(archive)/layout/(review)/list/Comment';

interface CommentReply {
    databaseId: number;
    replies?: {
        nodes: CommentReply[];
    };
    // Add other fields as necessary
}

export interface CommentNode {
    databaseId: number;
    parent: number | null;
    commentedOn: {
        node: {
            databaseId: number;
        };
    };
    replies: {
        nodes: CommentReply[];
    };
    // Add other fields as necessary
}

export interface CommentsData {
    comments: {
        nodes: CommentNode[];
        pageInfo: {
            hasNextPage: boolean;
            endCursor: string;
        };
    };
}

interface ReviewsProps {
    currentPostId: number;
    commentCount: number;
    comments?: CommentNode[];
    hasNextPage?: CommentsData['comments']['pageInfo']['hasNextPage'];
}

const Reviews: FC<ReviewsProps> = ({ currentPostId, commentCount, comments, hasNextPage }) => {
    if (!Array.isArray(comments)) {
        return null;
    }

    return (
        <section className={'mt-4 flex flex-col gap-5 overflow-hidden'}>
            {comments.map((comment) => (
                <div
                    key={comment.databaseId}
                    className={`flex flex-col justify-between ${comment.parent == null ? 'border-b dark:border-white/15 border-gray-200 pb-6' : 'bg-bg dark:bg-white/10'} lg:p-3`}
                >
                    <Comment comment={comment} broker={undefined} />
                    {comment.replies.nodes.length > 0 && (
                        <ReviewReply comment={comment.replies.nodes[0]} />
                    )}
                    {countCommentReplies(comment.replies.nodes) > 1 && (
                        <ReviewAllReplies comment={comment} />
                    )}
                </div>
            ))}
            {hasNextPage && (
                <AllReviews currentPostId={currentPostId} commentCount={commentCount} />
            )}
        </section>
    );
};

export default Reviews;
